import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { AvailableAssociablePaymentMethodItem } from '@/models/ps-management/multi-methods.model';

export default class GetAvailableAssociablePaymentMethodListRequest
  extends ApiResourceMethod<AvailableAssociablePaymentMethodItem[]> {
  public perform(multiMethodId: string): Promise<AvailableAssociablePaymentMethodItem[]> {
    return this.performer.requestWithMapper(
      { url: `${multiMethodId}/availableBillingPaymentMethodList` },
      (payload: BaseResponse<AvailableAssociablePaymentMethodItem[]>) => {
        return payload.data;
      },
    );
  }
}
